import React from "react"
import "./styles.scss"

function AppstoreBadge(props) {
  return (
    <div class="appstoreBadge">
      <a
          class="badge"
          href="https://apps.apple.com/us/app/diskmate/id1467915119?mt=12"
        ></a>
    </div>
  )
}

export default AppstoreBadge
